type Listener<Payload> = (payload: Payload) => void;

class TypedEventEmitter<EventMap extends Record<string, unknown>> {
	private listeners: { [EventName in keyof EventMap]?: Set<Listener<EventMap[EventName]>> } = {};

	on<EventName extends keyof EventMap>(event: EventName, listener: Listener<EventMap[EventName]>): void {
		const existing = this.listeners[event] ?? new Set<Listener<EventMap[EventName]>>();
		existing.add(listener);
		this.listeners[event] = existing;
	}

	off<EventName extends keyof EventMap>(event: EventName, listener: Listener<EventMap[EventName]>): void {
		this.listeners[event]?.delete(listener);
	}

	emit<EventName extends keyof EventMap>(event: EventName, payload: EventMap[EventName]): void {
		[...(this.listeners[event] ?? [])].forEach((listener) => {
			try {
				listener(payload);
			} catch (error: unknown) {
				console.warn('EVENT BUS -> listener threw ->', error);
			}
		});
	}

	removeAllListeners(event?: keyof EventMap): void {
		if (event === undefined) {
			this.listeners = {};
		} else {
			delete this.listeners[event];
		}
	}

	listenerCount(event: keyof EventMap): number {
		return this.listeners[event]?.size ?? 0;
	}
}

export default TypedEventEmitter;
